import React, { useMemo } from 'react'
import chunk from 'lodash/chunk'
import AvatarIcon from './icons/AvatarIcon'
import AppleIcon from './icons/AppleIcon'
import BriefCaseIcon from './icons/BriefCaseIcon'
import BuildingIcon from './icons/BuildingIcon'
import CannabisIcon from './icons/CannabisIcon'
import CigaretteIcon from './icons/CigaretteIcon'
import DrugsIcon from './icons/DrugsIcon'
import FeederIcon from './icons/FeederIcon'
import GlassIcon from './icons/GlassIcon'
import GlobeIcon from './icons/GlobeIcon'
import GraduationCapIcon from './icons/GraduationCapIcon'
import MagnifyingGlassIcon from './icons/MagnifyingGlassIcon'
import PawIcon from './icons/PawIcon'
import PrayIcon from './icons/PrayIcon'
import TapeRuleIcon from './icons/TapeRuleIcon'
import WeightIcon from './icons/WeightIcon'

const profileIconsMap = {
  location: GlobeIcon,
  desiredAgeRange: AvatarIcon,
  alcohol: GlassIcon,
  cannabis: CannabisIcon,
  desiredRelationship: MagnifyingGlassIcon,
  diet: AppleIcon,
  drugs: DrugsIcon,
  education: GraduationCapIcon,
  exercise: WeightIcon,
  haveChildren: FeederIcon,
  height: TapeRuleIcon,
  occupation: BriefCaseIcon,
  pets: PawIcon,
  politics: BuildingIcon,
  religion: PrayIcon,
  smoking: CigaretteIcon,
}

const ProfileTags = ({ user }) => {
  const tags = useMemo(() => {
    const profile = {
      location: user.location,
      ...(user?.profile || {}),
    }
    const allTags = Object.keys(profileIconsMap)
      .filter(key => profile[key])
      .map(key => ({
        Icon: profileIconsMap[key],
        text: profile[key],
      }))
    return allTags.length ? chunk(allTags, Math.ceil(allTags.length / 2)) : []
  }, [user])

  if (!tags.length) {
    return null
  }

  return (
    <div className="overflow-x-scroll mb-6 scrollbar-hidden">
      {tags.map((tag, index) => (
        <div key={index} className="flex flex-nowrap mb-4">
          {tag.map(({ Icon, text }, tagIndex) => (
            <div
              className="flex flex-shrink-0 items-center bg-darkGray px-2.5 py-1.5 mr-2.5 rounded-2xl"
              key={tagIndex}
            >
              <Icon className="w-4 h-4 mr-1" />
              <div className="text-lightGray text-xs">{text}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default ProfileTags
